'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _linksoftAlbatros = require('linksoft-albatros');

var _actions = require('../../actions');

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    var amount = (0, _linksoftAlbatros.getCartAmountFor)(ownProps, state);
    return (0, _extends3.default)({}, ownProps, {
        amount: amount
    });
}

var mapDispatchToProps = {
    changeAmount: _actions2.default.changeAmount,
    removeItem: _actions2.default.removeItem
};

var GiftItem = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$PureComponent) {
    (0, _inherits3.default)(GiftItem, _React$PureComponent);

    function GiftItem() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, GiftItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GiftItem.__proto__ || (0, _getPrototypeOf2.default)(GiftItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleAmountChange = function (e) {
            (0, _linksoftAlbatros.numbersOnly)(e);
            var _this$props = _this.props,
                changeAmount = _this$props.changeAmount,
                giftId = _this$props.giftId;

            changeAmount({ giftId: giftId, amount: e.target.value });
        }, _this.handleIncrement = function () {
            var _this$props2 = _this.props,
                changeAmount = _this$props2.changeAmount,
                giftId = _this$props2.giftId,
                amount = _this$props2.amount;

            changeAmount({ giftId: giftId, amount: "" + (amount + 1) });
        }, _this.handleDecrement = function () {
            var _this$props3 = _this.props,
                changeAmount = _this$props3.changeAmount,
                giftId = _this$props3.giftId,
                amount = _this$props3.amount;

            if (amount > 0) {
                changeAmount({ giftId: giftId, amount: "" + (amount - 1) });
            }
        }, _this.handleDelete = function () {
            _this.props.removeItem({ giftId: _this.props.giftId });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(GiftItem, [{
        key: 'renderAvailability',
        value: function renderAvailability() {
            var _props = this.props,
                availability = _props.availability,
                dispatchDate = _props.dispatchDate,
                amountAvailable = _props.amountAvailable;

            var dispatchDateAsDate = dispatchDate ? new Date(dispatchDate) : null;
            var dispatchText = amountAvailable > 0 && dispatchDateAsDate > new Date() ? format(dispatchDateAsDate, 'd') : null;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'em',
                    { className: (0, _linksoftAlbatros.getAvailabilityColor)(availability) },
                    (0, _linksoftAlbatros.getAvailabilityText)(availability)
                ),
                _react2.default.createElement('br', null),
                !!dispatchText && _react2.default.createElement(
                    'em',
                    { className: 'red' },
                    dispatchText
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                productName = _props2.productName,
                url = _props2.url,
                amount = _props2.amount,
                pointsPrice = _props2.pointsPrice,
                summary = _props2.summary;

            return _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'td',
                    { className: 'table-view--title-name' },
                    _react2.default.createElement(
                        'a',
                        { href: url, className: 'cart-item__name' },
                        _react2.default.createElement(
                            'strong',
                            null,
                            productName
                        )
                    )
                ),
                _react2.default.createElement('td', null),
                _react2.default.createElement(
                    'td',
                    { className: 'text-center' },
                    !summary && _react2.default.createElement(
                        'div',
                        { className: 'cart-amount' },
                        _react2.default.createElement('button', { className: 'btn__square btn__square--minus', onClick: this.handleDecrement }),
                        _react2.default.createElement('input', { type: 'number', min: '0', value: amount, onChange: this.handleAmountChange }),
                        _react2.default.createElement('button', { className: 'btn__square btn__square--plus', onClick: this.handleIncrement })
                    ),
                    summary && _react2.default.createElement(
                        'span',
                        null,
                        amount
                    )
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'text-right nowrap' },
                    _react2.default.createElement(
                        'span',
                        { className: '' },
                        pointsPrice || 0,
                        '\xA0b.'
                    )
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                        'span',
                        { className: '' },
                        pointsPrice * amount || 0,
                        '\xA0b.'
                    )
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                        'button',
                        { className: 'btn__square cart-i__remove', onClick: this.handleDelete },
                        _react2.default.createElement('i', { className: 'icon--cross' })
                    )
                )
            );
        }
    }]);
    return GiftItem;
}(_react2.default.PureComponent)) || _class);
exports.default = GiftItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/GiftItem.js
// module id = 633
// module chunks = 0